/* @flow weak */
import AuthenticationView from 'auth/components/AuthenticationView.jsx';
import Device from 'entities/Device';
import enumerate from 'lib/enumerate';
import Link from 'components/Link.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import LinkConstants from 'constants/LinkConstants';
import React from 'react';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

import './styles/ConfirmEmailPage.scss';

const STATUS = enumerate([
  'pending',
  'failure',
]);

const expiredMessage = 'Your link has expired.';

class ConfirmEmailPage extends React.Component {
  static propTypes = {
    location: React.PropTypes.object.isRequired,
    params: React.PropTypes.object.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  state = {
    status: STATUS.pending,
    source: this.props.location.query.source,
  };

  /* We have 2 ways of confirming email addresses. (I know).
   * Confirming a User confirms the user's primary email address (and corresponding device).
   * Confirming a device confirms just that one device. They are different endpoints and
   * different types of tokens. User tokens are stateless meanwhile device tokens are stored
   * in the database. The stateless tokens are much larger. Here we determine the type of
   * token (and which endpoint to request) based on the length of the token. Thanks for
   * reading.
   * */
  componentDidMount() {
    const token = this.props.params.token;
    if (token.length > 36) {
      this.confirmUser(token);
    } else {
      this.confirmDevice(token);
    }
  }

  onSuccess = () => {
    ToastActions.showSuccessToast('Your email has been confirmed');
    this.context.router.push('/landing');
  };

  confirmUser = (token) => {
    UserActions
      .confirm(token, this.state.source)
      .then(this.onSuccess, error => {
        let errorMessage = 'An error has occurred.';
        if (error.statusCode === 403) {
          errorMessage = expiredMessage;
        } else if (error.statusCode === 422) {
          try {
            errorMessage = error.field_errors[0].messages[0] + '.';
          } catch (e) {
            // Do nothing.
          }
        }

        this.setState({
          status: STATUS.failure,
          errorMessage,
        });
      });
  };

  confirmDevice = (token) => {
    Device
      .confirmEmailDevice(token)
      .then(this.onSuccess, () => {
        this.setState({
          status: STATUS.failure,
          errorMessage: expiredMessage,
        });
      });
  };

  renderFailure = () => {
    return (
      <div className="ConfirmEmailPage-Failure">
        <h2 className="ConfirmEmailPage-Title">
          {this.state.errorMessage}
        </h2>

        <p>
          Please
          {' '}
          <Link href={LinkConstants.CONTACT_FORM} target="_blank">contact us</Link>.
        </p>
      </div>
    );
  };

  renderPending = () => {
    return (
      <div className="ConfirmEmailPage-Pending">
        <h2 className="ConfirmEmailPage-Title">
          Confirming your new email address...
        </h2>

        <div className="ConfirmEmailPage-Loading">
          <LoadingIndicator size="small" />
        </div>
      </div>
    );
  };

  render() {
    const body = {
      [STATUS.pending]: this.renderPending,
      [STATUS.failure]: this.renderFailure,
    }[this.state.status]();

    return (
      <AuthenticationView>
        <div className="ConfirmEmailPage">
          {body}
        </div>
      </AuthenticationView>
    );
  }
}

export default ConfirmEmailPage;



// WEBPACK FOOTER //
// ./src/auth/components/ConfirmEmailPage.jsx